import { render, staticRenderFns } from "./BusinessPlanAdditionalInfo.vue?vue&type=template&id=bffca4c6&scoped=true"
import script from "./BusinessPlanAdditionalInfo.vue?vue&type=script&lang=js"
export * from "./BusinessPlanAdditionalInfo.vue?vue&type=script&lang=js"
import style0 from "./BusinessPlanAdditionalInfo.vue?vue&type=style&index=0&id=bffca4c6&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bffca4c6",
  null
  
)

export default component.exports